import React, {PureComponent} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {addPictureToCanvas} from "../../../AC/add-picture-to-canvas";
import {removePicture} from "../../../AC/remove-picture";
import LazyLoad from "react-lazyload";

export class Picture extends PureComponent {
  static propTypes = {
    type: PropTypes.string,
    picture: PropTypes.object,
    addPictureToCanvas: PropTypes.func,
    removability: PropTypes.bool,
    removePicture: PropTypes.func,
    onRequestCloseModal: PropTypes.func
  };
  addPictureToCanvas = (params) => (e) => {
    const {type} = this.props;
    let flag;
    if (type === `images`) {
      flag = `isLocal`;
    } else if (type === `cliparts`) {
      flag = `isClipart`;
    } else if (type === `textures`) {
      flag = `isTexture`;
    }
    e.preventDefault();
    this.props.addPictureToCanvas(params, {
      [flag]: true
    });
    this.props.onRequestCloseModal();
  };
  removePicture = (params) => () => {
    this.props.removePicture(params);
  };
  render() {
    const {
      picture: {preview, ...params},
      removability
    } = this.props;
    return (
      <div className="picture">
        <a
          href="#"
          className="picture__img"
          onClick={this.addPictureToCanvas(params)}
        >
          <LazyLoad
            overflow={true}
            height={200}
            offset={100}
            placeholder={<p>Загрузка...</p>}
          >
            <img loading="lazy" src={preview} />
          </LazyLoad>
        </a>
        {removability && (
          <button
            className="picture__remove"
            onClick={this.removePicture(params)}
          >
            ×
          </button>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = {
  addPictureToCanvas,
  removePicture
};

export default connect(null, mapDispatchToProps)(Picture);
